import type { TherapistOfficeDistrictItem } from '@hedepy/common/schemas/routes/api/v2/therapist'
import { CompanyIcon } from '@hedepy/icons/refactor/Company'
import { useMemo } from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { TherapistFilterMenuGroupUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuGroup'
import { TherapistFilterMenuLabelUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuLabel'
import { TherapistFilterMenuSeparatorUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuSeparator'
import { TherapistSessionLocationFilterItemUI } from '@/src/domains/therapist-filters/components/TherapistSessionLocationFilterItem'

export interface ClinicTherapistSessionLocationFilterProps {
  checked: number[]
  onCheckedChange: (checked: boolean, id: number) => void
  districts: TherapistOfficeDistrictItem[]
}

export const ClinicTherapistSessionLocationFilter = ({
  checked,
  onCheckedChange,
  districts,
}: ClinicTherapistSessionLocationFilterProps) => {
  const { t } = getTranslate()

  const clinicDistricts = useMemo(() => districts.filter(({ clinic }) => clinic), [districts])

  if (clinicDistricts.length === 0) {
    return null
  }

  return (
    <>
      <TherapistFilterMenuGroupUI className="m-5">
        <TherapistFilterMenuLabelUI Icon={CompanyIcon}>
          {t('component.therapist.filter.event-location.clinic.title')}
        </TherapistFilterMenuLabelUI>
        <div className="flex flex-col gap-5">
          {clinicDistricts.map(({ id, districtName, regionName }) => (
            <TherapistSessionLocationFilterItemUI
              key={id}
              name={districtName}
              regionName={regionName}
              clinic
              displayRegion
              checked={checked.includes(id)}
              onChange={(checked) => {
                onCheckedChange(checked, id)
              }}
            />
          ))}
        </div>
      </TherapistFilterMenuGroupUI>
      <TherapistFilterMenuSeparatorUI />
    </>
  )
}
